export default __webpack_public_path__ + "static/media/information--parking-with-restrictions--g1.55284b47.png";